<template>
  <div class="contenitore-ricerca row row-custom">
    <div class="pannello col-lg-8 col-md-8 col-sm-12 col-24 no-padding" v-loading="filtri.loading">
      <div class="header-search row row-custom">
        <div class="titolo col-22 no-padding">
          {{ filtri.titolo }}
        </div>
        <div class="chiudi col-2 no-padding">
          <icon name="elm-chiudi" scale="1" class="pointer" @click.native="closeRicerca"></icon>
        </div>
      </div>
      <div class="content-search">
        <div class="elemento col-24" v-for="(item, index) in filtri.filtri" :key="index"
          v-if="(item.type !== 'input-codForn') || ((item.type == 'input-codForn') && (item.typeOfUser === 'admin'))">
          <div class="search-label" v-if="(!shouldHide(item))">
            {{ item.myLabel + ':' }}
          </div>

          <el-select v-if="(item.type === 'select' && !shouldHide(item))" class="col-24 no-padding" v-model="filtri.valueSelected[index]"
            placeholder="" :clearable="item.ifClearable" :disabled="item.ifDisabled"
            @change="changeValueOrClick(index)">
            <el-option v-for="option in filtri.dati[index]" :label="option[item.label]" :key="option[item.key]"
              :value="option[item.value]">
            </el-option>
          </el-select>

          <div v-if="(item.type === 'input-codForn')" class="row row-custom">
            <el-input class="col-20 no-padding" v-model="filtri.valueSelected[index]" placeholder=""></el-input>
            <div class="div-bottone offset-1 col-3 no-padding">
              <el-button @click="changeValueOrClick(index)">
                <icon name="riv-tick" scale="1.1"></icon>
              </el-button>
            </div>
          </div>

          <el-date-picker v-if="(item.type === 'dt-picker')" :format="item.format" :value-format="item.valueFormat"
            :type="item.typePicker" placeholder="" v-model="filtri.valueSelected[index]" :clearable="item.ifClearable"
            @change="changeValueOrClick(index)">
          </el-date-picker>

          <el-input v-if="(item.type === 'input')" class="col-24 no-padding" v-model="filtri.valueSelected[index]"
            placeholder="" :clearable="item.ifClearable" @change="changeValueOrClick(index)"></el-input>

          <el-checkbox-group v-if="(item.type === 'checkbox')" v-model="filtri.valueSelected[index]">
            <el-checkbox v-for="item in filtri.dati[index]" :label="option[item.value]"
              :key="option[item.key]">{{ item.value }}</el-checkbox>
          </el-checkbox-group>

          <el-checkbox v-if="(item.type === 'checkbox')" v-model="filtri.valueSelected[index]"></el-checkbox>

        </div>

        <div class="bottoni col-24">
          <el-button @click="cerca" class="WEB-button WEB-button-primary">
            {{ $t('ricerca.cerca').toUpperCase() }}
          </el-button>
        </div>
      </div>
    </div>
    <div class="bg-oscurato col-lg-16 col-md-16 col-sm-12 hidden-xs no-padding"></div>
  </div>
</template>

<script>
export default {
  name: 'RicercaPanel',
  props: {
    filtri: {
      type: Object
    }
  },
  i18n: {
    messages: {
      it_IT: {
        ricerca: {
          cerca: 'Cerca'
        }
      },
      fr_FR: {
        ricerca: {
          cerca: 'Recherche'
        }
      },
      es_ES: {
        ricerca: {
          cerca: 'Búsqueda'
        }
      },
      de_DE: {
        ricerca: {
          cerca: 'Suche'
        }
      },
      en_GB: {
        ricerca: {
          cerca: 'Search'
        }
      }
    }
  },
  data() {
    return {}
  },
  methods: {
    changeValueOrClick: function (index, value) {
      this.$emit('changeValueOrClick', index, value)
    },
    cerca: function () {
      this.$emit('cerca')
    },
    closeRicerca: function () {
      this.$emit('closeRicerca')
    },
    shouldHide(item) {
      const country = this.$store.state.country

      // Se ifHide NON ESISTE → mai nascondere
      if (item.ifHide === undefined || item.ifHide === null) {
        return false
      }

      // Se ifHide è BOOLEANO → funziona come prima
      if (typeof item.ifHide === 'boolean') {
        return item.ifHide
      }

      // Se ifHide è FUNZIONE → delega alla funzione
      if (typeof item.ifHide === 'function') {
        return item.ifHide(country)
      }

      return false;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
@import "../../assets/less/general.less";
@import "../../assets/less/el-button.less";

.el-select-dropdown {
  .el-select-dropdown__item {
    height: 22px;
    line-height: 22px;
    padding: 0px 10px;
    .set-font(@size: 11px; @color: #666);

    span {
      line-height: 22px !important;
    }
  }
}

.contenitore-ricerca {
  height: 100%;
  width: 100%;

  .bg-oscurato {
    height: 100%;
    background-color: #5d5d5d;
    opacity: 0.7;
  }

  .pannello {
    height: 100%;
    background-color: #fff;
    opacity: 1;
    overflow: auto;
    z-index: 10;

    .header-search {
      margin-top: 10px;
      line-height: 20px;
      padding: 0px 15px;
      width: 100%;

      .chiudi {
        text-align: right;

        .pointer:hover {
          cursor: pointer;
        }
      }

      .titolo {
        .set-font(@color: @oroRiva, @size: 24px, @weight: bold, @family: 'os-lightitalic');
        text-align: left;

        letter-spacing: 2px;
        padding-top: 5px;
      }
    }

    .content-search {
      margin-top: 40px;

      .elemento {
        margin-bottom: 20px;

        .search-label {
          float: left;
          .set-font(@color: @greenRiva; @size: 14px);
        }

        .el-date-editor {
          width: 100%;

          .el-input__prefix {
            left: -5px;

            .el-input__icon {
              line-height: 0px;
            }
          }

          .el-input__suffix {
            right: 0px;

            .el-input__icon {
              line-height: 0px;
            }
          }

          .el-input__inner {
            padding-left: 25px !important;
          }
        }

        .el-select {
          height: 22px;
          line-height: 22px;

          .is-focus {
            border: 0px;
          }

          .el-input {
            .el-input__inner {
              height: 22px !important;
              line-height: 0px;
              padding-left: 0px;
              padding-right: 25px;
              border: 0px;
              border-radius: 0px;
              border-bottom: 1px solid @greenRiva;
              background-color: @white;
              font-size: 12px;
            }

            .el-input__inner:focus {
              border: 0px !important;
              border-bottom: 1px solid @greenRiva !important;
            }
          }

          .el-input__suffix {
            right: 0px;

            .el-input__suffix-inner {
              .el-input__icon {
                line-height: 0px;
              }
            }
          }
        }

        .el-input {
          .el-input__inner {
            height: 22px;
            line-height: 0px;
            padding-left: 0px;
            padding-right: 5px;
            width: 100%;
            border: 0px;
            border-bottom: 1px solid @greenRiva;
            border-radius: 0px;
            font-size: 12px;
          }

          .el-input__suffix {
            right: 0px;
          }
        }
      }

      .bottoni {
        text-align: right;
        margin-top: 25px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ServiceComponents/RicercaPanel.vue